import { __awaiter, __generator, __read, __spreadArray } from "tslib";
import { createContext } from './query-job';
var QueryJobUnion = /** @class */ (function () {
    function QueryJobUnion(node, parent) {
        this.node = node;
        this.parent = parent;
        this.context = createContext(node);
    }
    QueryJobUnion.prototype.perform = function (output) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                output.push(this.context.inputs.reduce(function (prev, next) {
                    prev.push.apply(prev, __spreadArray([], __read(next)));
                    return prev;
                }, []));
                return [2 /*return*/];
            });
        });
    };
    return QueryJobUnion;
}());
export { QueryJobUnion };
export default QueryJobUnion;
//# sourceMappingURL=query-job-union.js.map